//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../GeometricAnalysis/GeometricAnalysis.FaceAnalysisDataRangeBuilder.js";
import "../GeometricAnalysis/GeometricAnalysis.FaceAnalysisDisplayBuilder.js";
import "../Features/Features.GeometricConstraintDataManager.js";
import "../no/SelectDisplayableObjectList.js";
import "../GeometricAnalysis/GeometricAnalysis.FaceAnalysisNormalsBuilder.js";
import "../no/Features.js";
import "../no/SelectObjectList.js";
let d=[[[1,"DataRange",0,"GeometricAnalysis.FaceAnalysisDataRangeBuilder",1],[0,"DisplayMode",1,1],[1,"DisplaySettings",0,"GeometricAnalysis.FaceAnalysisDisplayBuilder",1],[1,"DynamicLabel",0,"Features.GeometricConstraintDataManager",1],[1,"Faces",0,"SelectDisplayableObjectList",1],[1,"Normals",0,"GeometricAnalysis.FaceAnalysisNormalsBuilder",1],[0,"NumberOfContourLines",1,1],[0,"Plane",1,"Plane",1],[0,"SpikeLength",1,1],[0,"Type",1,1],[0,"Vector",1,"Direction",1]],[[[],"UpdateDisplayOnPlaneChange",{},0,1],[[],"StartRadiusAnalysis",{},0,1]],[]];
SPLM.GeometricAnalysis.RadiusAnalysisBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.RadiusAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.RadiusAnalysisBuilder.Types = Object.freeze({
    "Gaussian" : "Gaussian", "Minimum" : "Minimum", "Maximum" : "Maximum", "Mean" : "Mean", "Normal" : "Normal", "Sectional" : "Sectional", "U" : "U", "V" : "V"});

SPLM.GeometricAnalysis.RadiusAnalysisBuilder.DisplayModes = Object.freeze({
    "Fringe" : "Fringe", "Hedgehog" : "Hedgehog", "ContourLines" : "ContourLines"});

export default SPLM;